import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      background: palette.background.box,
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.boxShadow,
      fontFamily: 'montserrat',
      fontWeight: 600,
      color: palette.text.primary,
      padding: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
